module.exports = __webpack_public_path__ + "img/li-circle-blue.b22b26c3.svg";